import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BaseService } from '../../../base/base.service';
import { Config } from '../../../models/Config';
@Injectable({
  providedIn: 'root'
})
export class DiliveryService extends BaseService {

  httpClient = inject(HttpClient);
  constructor() {
    super();
  }
    /*
     *   function name: despositEntry()
     *   functionality: ownership master deatails
     *   parameters : {}
     */
    deliverySearch(data: any) {
      return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_delivery_challan_plant_code`, data, this.getConfig())
    }
    deliverySubmit(data: any) {
      return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_delivery_challan`, data, this.getConfig())
    }
    // getDeliviryChalan() {
    //   return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/cng_delivery_challan`, this.getConfig())
    // }
}
